// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_role__5Naq2 {
  margin-bottom: 5px;
}
.Table_role__5Naq2 .Table_green__eSx\\+i {
  border-radius: 3px;
  border: 1px solid var(--institution-role);
  color: var(--institution-role);
  color: #289a00;
  width: fit-content;
  padding: 3px 10px;
  font-weight: 600;
}
.Table_role__5Naq2 .Table_gold__vTUTU {
  border-radius: 3px;
  border: 1px solid var(--personal-role);
  color: var(--personal-role);
  width: fit-content;
  padding: 3px 10px;
  font-weight: 600;
}
.Table_role__5Naq2 .Table_purple__m2dEj {
  border-radius: 3px;
  border: 1px solid var(--unit-role);
  color: var(--unit-role);
  width: fit-content;
  padding: 3px 10px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/AccountList/Components/Table/Table.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,yCAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,kCAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAEJ","sourcesContent":[".role {\n  margin-bottom: 5px;\n  .green {\n    border-radius: 3px;\n    border: 1px solid var(--institution-role);\n    color: var(--institution-role);\n    color: #289a00;\n    width: fit-content;\n    padding: 3px 10px;\n    font-weight: 600;\n  }\n  .gold {\n    border-radius: 3px;\n    border: 1px solid var(--personal-role);\n    color: var(--personal-role);\n    width: fit-content;\n    padding: 3px 10px;\n    font-weight: 600;\n  }\n  .purple {\n    border-radius: 3px;\n    border: 1px solid var(--unit-role);\n    color: var(--unit-role);\n    width: fit-content;\n    padding: 3px 10px;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"role": `Table_role__5Naq2`,
	"green": `Table_green__eSx+i`,
	"gold": `Table_gold__vTUTU`,
	"purple": `Table_purple__m2dEj`
};
export default ___CSS_LOADER_EXPORT___;
